/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Workout_Highlights_NumberInputs */

const en_us2_workout_highlights_number = /** @type {(inputs: Workout_Highlights_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Workout #${i?.n}`)
};

const pt_br2_workout_highlights_number = /** @type {(inputs: Workout_Highlights_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino nº ${i?.n}`)
};

const es_419_workout_highlights_number = /** @type {(inputs: Workout_Highlights_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entrenamiento n.º ${i?.n}`)
};

const pt_pt2_workout_highlights_number = /** @type {(inputs: Workout_Highlights_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Treino n.º ${i?.n}`)
};

const fr_fr2_workout_highlights_number = /** @type {(inputs: Workout_Highlights_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séance nº ${i?.n}`)
};

const de_de2_workout_highlights_number = /** @type {(inputs: Workout_Highlights_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Training Nr. ${i?.n}`)
};

const it_it2_workout_highlights_number = /** @type {(inputs: Workout_Highlights_NumberInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Allenamento n. ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Workout #{n}" |
*
* @param {Workout_Highlights_NumberInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_number = /** @type {((inputs: Workout_Highlights_NumberInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_NumberInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_number(inputs)
	if (locale === "es-419") return es_419_workout_highlights_number(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_number(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_number(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_number(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_number(inputs)
	return en_us2_workout_highlights_number(inputs)
});
export { workout_highlights_number as "workout-highlights.number" }